import { FC } from "react";
import UsersList from "@/pages/settings/users/user.page.list";

const SettingsUsersPage: FC = () => {
    return (
        <div key="user_management_wrapper" className="user_management_wrapper">
            <UsersList></UsersList>
        </div>
    );
};

export default SettingsUsersPage;
